import { useContext, useEffect } from 'react';
import { useLocation, Redirect } from 'react-router-dom';

import AuthContext from '../../store/AuthContext';
import AuthCode from "./AuthCode";
import AccessToken from "./AccessToken";
import DecodedToken from "./DecodedToken";
import AuthMd from "./AuthMd";
import * as utils from '../../services/utils';

function Authorize() {
  const location = useLocation();
  const iuaCtx = useContext(AuthContext);

  const transType = sessionStorage.getItem('transType');
  const isAuthCodeType = (transType === utils.TRANS.auth_code);
  const isMdType = (transType === utils.TRANS.auth_metadata);

  useEffect(() => {
    if (location.search) {
      iuaCtx.setAuthSearchData(location.search);
    } 
  }, []);

  return <div>
    <div className="container main-body">
      <div className="main-form">

        <div className="row">
          <div className="col-8">
            {isAuthCodeType && <div>
              <AuthCode></AuthCode>
              <Redirect to="/authorize" />
            </div>}
            {!isMdType && <div>
              <AccessToken></AccessToken>
              <DecodedToken></DecodedToken>
            </div>}
           </div>
        </div>

        {isMdType && <div className="row">
          <div className="col-12">
          <AuthMd></AuthMd>
          </div>
        </div>}

        {/* {utils.cleanup()} */}
        
      </div>
    </div>
  </div>
}

export default Authorize;